(function () {
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));

  const mix = (from, to, amount) => from + (to - from) * amount;

  const mapRange = (value, input, output) => {
    if (value <= input[0]) return output[0];
    if (value >= input[input.length - 1]) return output[output.length - 1];

    for (let i = 0; i < input.length - 1; i += 1) {
      if (value >= input[i] && value <= input[i + 1]) {
        const progress = (value - input[i]) / (input[i + 1] - input[i]);
        return mix(output[i], output[i + 1], progress);
      }
    }

    return output[output.length - 1];
  };

  const initJourney = (section) => {
    const sticky = section.querySelector("[data-journey-sticky]");
    const intro = section.querySelector("[data-journey-intro]");
    const introPrompt = section.querySelector("[data-journey-intro-prompt]");
    const panels = Array.from(section.querySelectorAll("[data-journey-panel]"));
    const progressCircle = section.querySelector("[data-journey-progress]");
    const markers = Array.from(section.querySelectorAll("[data-journey-marker]"));
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const mobileQuery = window.matchMedia("(max-width: 749px)");

    if (!sticky || !panels.length) return;

    const hasIntro = section.dataset.hasIntro !== "false" && Boolean(intro);
    const introSegments = hasIntro ? 1 : 0;
    const total = panels.length + introSegments;

    section.style.setProperty("--journey-length", `${total * 140}vh`);

    const render = () => {
      const rect = section.getBoundingClientRect();
      const scrollable = Math.max(section.offsetHeight - window.innerHeight, 1);
      const progress = clamp(-rect.top / scrollable);
      const segment = 1 / total;
      const isMobile = mobileQuery.matches;

      if (progressCircle) {
        const slideProgress = hasIntro
          ? clamp((progress - segment) / (1 - segment))
          : progress;

        progressCircle.style.setProperty("--progress", `${slideProgress * 100}%`);
      }

      if (hasIntro) {
        const introLocal = clamp(progress / segment);

        intro.style.opacity = mapRange(introLocal, [0, 0.55, 0.9], [1, 1, 0]);
        intro.style.transform = `translate3d(0, ${mapRange(introLocal, [0, 0.9], [0, -32])}px, 0)`;

        if (introPrompt && !prefersReduced) {
          introPrompt.style.transform = `translate3d(0, ${mapRange(introLocal, [0, 0.5, 1], [0, 8, 0])}px, 0)`;
        }
      }

      panels.forEach((panel, index) => {
        const panelIndex = index + introSegments;
        const local = clamp((progress - panelIndex * segment) / segment);
        const startsOnFirstSlide = !hasIntro && index === 0;
        const figure = panel.querySelector("[data-journey-figure]");
        const copy = panel.querySelector("[data-journey-copy]");
        const side = isMobile ? 50 : panel.dataset.side === "right" ? 72 : 28;

        const imageOpacity = startsOnFirstSlide
          ? mapRange(local, [0, 0.88, 1], [1, 1, 0])
          : mapRange(local, [0, 0.08, 0.88, 1], [0, 1, 1, 0]);

        const imageX = isMobile || startsOnFirstSlide
          ? side
          : mapRange(local, [0, 0.3, 0.62, 1], [50, 50, side, side]);

        const imageScale = prefersReduced
          ? mapRange(local, [0, 0.15, 0.85, 1], [0.95, 1, 1, 0.95])
          : startsOnFirstSlide
            ? mapRange(local, [0, 0.88, 1], [1, 1, 0.92])
            : isMobile
              ? mapRange(local, [0, 0.22, 0.78, 1], [0.82, 1.12, 1.12, 0.96])
              : mapRange(local, [0, 0.3, 0.62, 0.88, 1], [0, 1.34, 1, 1, 0.92]);

        const copyOpacity = startsOnFirstSlide
          ? mapRange(local, [0, 0.88, 1], [1, 1, 0])
          : isMobile
            ? mapRange(local, [0.32, 0.46, 0.88, 1], [0, 1, 1, 0])
            : mapRange(local, [0.62, 0.74, 0.88, 1], [0, 1, 1, 0]);

        const copyY = startsOnFirstSlide
          ? mapRange(local, [0, 0.88], [0, -8])
          : isMobile
            ? mapRange(local, [0.32, 0.88], [24, 0])
            : mapRange(local, [0.62, 0.88], [32, -8]);

        if (figure) {
          figure.style.opacity = imageOpacity;
          figure.style.transform = `translate3d(-50%, -50%, 0) translateX(${imageX - 50}vw) scale(${imageScale})`;
        }

        if (copy) {
          copy.style.opacity = copyOpacity;
          copy.style.transform = `translate3d(0, ${copyY}px, 0)`;
        }
      });

      markers.forEach((marker, index) => {
        const markerIndex = index + introSegments;
        const active = progress >= markerIndex * segment - 0.02 && progress < (markerIndex + 1) * segment + 0.02;
        marker.style.opacity = active ? "1" : "0.3";
      });
    };

    let ticking = false;

    const requestRender = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(() => {
        render();
        ticking = false;
      });
    };

    render();

    window.addEventListener("scroll", requestRender, { passive: true });
    window.addEventListener("resize", requestRender);

    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change", requestRender);
    }
  };

  document.querySelectorAll("[data-cask-journey]").forEach(initJourney);
})();